import { render, staticRenderFns } from "./SpecialFooter.vue?vue&type=template&id=37c2281a&scoped=true&"
import script from "./SpecialFooter.vue?vue&type=script&lang=ts&"
export * from "./SpecialFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialFooter.vue?vue&type=style&index=0&id=37c2281a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c2281a",
  null
  
)

export default component.exports